
import React from 'react'
import { Link } from 'react-router-dom' 
 import $ from 'jquery'

class PageNotFound extends React.Component{
    // componentDidMount(){
    //     $('#root').addClass('error-page')
    // }
    // componentWillUnmount(){
    //      $('$root').removeClass('error-page')
    // }
    render(){
        return(
        <div className='error-page'>
            <section className="error">
            <div className="error-body">
                <div className="twinkling"></div>
                <div className="error-content">
                <div className="img-notfound"></div>
                <div className="text">
                    <p className="p-error-page">Oops..Lost in space?</p>
                    <p className="p-error-page">The galaxy you are looking for doesn't exist</p>
                </div>
                <div className="link"><Link to={`/`}>Go Back</Link></div>
                </div>
            </div>
            </section>
        </div>
        
        )
    }
}
 
export default PageNotFound

